import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import FadeBox from "../../components/animate/FadeBox";
import FGInput from "../../components/dumb/FGInput";
import Config from "../../config/config";
import useAuthUser from "../../hooks/use-auth-user";
import usePageTitle from "../../hooks/use-page-title";
import { ROUTES } from "../../routes";
import ApiAuth from "../../modules/api/auth";
import Debouncer from "../../modules/debouncer/debouncer";
import Notifier from "../../modules/notifier/notifier";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const PAGE_TITLE = "Reset Password";

export default function PageForgotPassword() {
  usePageTitle(PAGE_TITLE);
  const auth = useAuthUser();
  const navigate = useNavigate();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const refInputEmail = useRef<HTMLInputElement>();
  const [showSubmitted, setShowSubmitted] = useState(false);

  useEffect(() => {
    if (Config.IS_MOCKUP_MODE) return;

    if (!auth.isLoading && auth.user.logged) {
      navigate(ROUTES.PORTAL_DASHBOARD);
    }
  }, [auth]);

  const handleOnSubmit = async (e: any) => {
    e.preventDefault();

    if (Config.IS_MOCKUP_MODE) {
      return;
    }

    const recaptchaV3Token = await executeRecaptcha("forgotPassword");

    Debouncer.execute("FORGOT_PASSWORD", async () => {
      const req = await ApiAuth.forgotPassword(refInputEmail.current.value, recaptchaV3Token);

      if (req.status) {
        refInputEmail.current.value = "";
        Notifier.success(req.message);
      } else {
        Notifier.error(req.message);
      }
    });
  };

  return (
    <div className="PA__main">
      <FadeBox show={!showSubmitted}>
        <form className="form-default" onSubmit={handleOnSubmit}>
          <h1>{PAGE_TITLE}</h1>

          <FGInput
            label="Enter the email address associated with your GROW-Pro account for us to send you a link to reset your password."
            placeholder=""
            autoFocus
            required
            type="email"
            ref={refInputEmail}
            autoComplete="off"
          />

          <p className="text-center">
            <button type="submit" className="btn btn-secondary">
              Submit
            </button>
          </p>

          <p className="text-center mb-0">
            <Link to={ROUTES.AUTH_LOGIN} className="link-grey">Back</Link>
          </p>
        </form>
      </FadeBox>

      <FadeBox show={showSubmitted}>
        <div>
          <h1>Check Your Email</h1>
          <p className="mb-5">
            We have sent you a reset password link to <br />
            <strong>example@student.com</strong>
          </p>
          <p className="text-center mb-0">
            Did not receive the email? Check your spam filter <br />
            or{" "}
            <a
              href="javascript:void(0);"
              onClick={(e) => {
                e.preventDefault();
                setShowSubmitted(false);
              }}
            >
              try another email address
            </a>
          </p>
        </div>
      </FadeBox>
    </div>
  );
}
